import { useLang } from "hooks/useLang"
import tags from "./tags.json"

const EventTagsComponent = ({ title }: { title: string }) => {
    return (
        <div
            className="h-[34px] sm:h-[38px] bg-[#FFFFFF1A] px-3 sm:px-4 flex items-center justify-center border-[#B5B5B5] border-[1px]
             dark:border-white/30 rounded-[25px] text-xs sm:text-sm font-medium tracking-wide
             transition-all cursor-default
             whitespace-nowrap"
        >
            <span className="capitalize">{title}</span>
        </div>
    )
}

const RenderEventTags = () => {
    const { isAr } = useLang()
    return (
        <div className="flex flex-row  select-none   gap-4  py-1">
            {tags.map((tag: { ar: string; en: string }) => (
                <EventTagsComponent key={tag.en} title={isAr ? tag.ar : tag.en} />
            ))}
        </div>
    )
}

export default RenderEventTags
